export default __webpack_public_path__ + "static/delhi-cover-fb07530c885a4b49adf9fa84b9d99be0.jpg";